import gql from "graphql-tag";
const updateUserActivityMutation = gql(`
mutation updateUserActivity($input: UpdateUserActivityInput!) {
  updateUserActivity(input: $input) {
    userid
    nickname
    credits
    samples
    rawsamples
    route
    calculators
    lastactivity
    planType
    renewal
    version
    subRenewal
  }
}
`)
export default updateUserActivityMutation;
